import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
class TooManyIssuesMessage extends Component {
    render() {
        const { file, onLoadClick, standalone, t } = this.props;
        const spinner = (_jsxs("span", { className: "mt-2 mb-2 d-block text-center", children: [_jsx(Icon, { name: "spinner", spin: true, fixedWidth: true, className: "mr-2" }), t('loading')] }));
        const loadMore = (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "info-circle-o mr-2" }), t('tooManyIssues'), _jsx("button", { className: "btn btn-link", onClick: () => onLoadClick(file.filePath), children: t('loadIssues') })] }));
        const content = file.loadingMessages ? spinner : _jsx("span", { className: "report-detail__code-more", children: loadMore });
        return (_jsx("p", { className: clsx('report-detail__code', !standalone && 'report-detail__code--truncated'), children: content }));
    }
}
TooManyIssuesMessage.defaultProps = {
    standalone: true,
};
export default withTranslation()(TooManyIssuesMessage);
